import useFetch from '../../../hooks/useFetch';
import notificationApi from '../NotificationApi';

export default function useSubscribeApi() {
    return useFetch(notificationApi.subscribe);
}
